const LABELS: Record<string, string> = {
  'auth.login': 'Anmeldung',
  'auth.login_failed': 'Fehlgeschlagene Anmeldung',
  'auth.account_locked': 'Konto gesperrt (Fehlversuche)',
  'auth.logout': 'Abmeldung',
  'auth.password_reset_requested': 'Passwort-Reset angefordert',
  'auth.password_reset': 'Passwort zurückgesetzt',
  'auth.password_changed': 'Passwort geändert',
  'auth.invitation_accepted': 'Einladung angenommen',
  'auth.email_verified': 'E-Mail bestätigt',
  'auth.session_revoked': 'Session beendet',
  'user.created': 'Benutzer angelegt',
  'user.updated': 'Benutzer geändert',
  'user.profile_updated': 'Profil geändert',
  'user.invitation_sent': 'Einladung versendet',
  'user.unlocked': 'Sperre aufgehoben',
  'user.sessions_revoked': 'Sessions beendet',
  'role.created': 'Rolle angelegt',
  'role.updated': 'Rolle geändert',
  'role.deleted': 'Rolle gelöscht',
  'tenant.provisioned': 'Mandant eingerichtet',
  'tenant.updated': 'Unternehmensdaten geändert',
  'tenant.logo_uploaded': 'Logo hochgeladen',
  'tenant.logo_removed': 'Logo entfernt',
  'tenant.favicon_uploaded': 'Favicon hochgeladen',
  'tenant.favicon_removed': 'Favicon entfernt',
  'tenant.sequence_updated': 'Nummernkreis geändert',
  'platform.tenant_created': 'Mandant angelegt',
  'platform.tenant_updated': 'Mandant geändert',
  'platform.domain_added': 'Domain hinzugefügt',
  'platform.domain_removed': 'Domain entfernt',
  'platform.domain_primary': 'Primäre Domain geändert',
  'customer.created': 'Kunde angelegt',
  'customer.updated': 'Kunde geändert',
  'customer.archived': 'Kunde archiviert',
  'customer.restored': 'Kunde reaktiviert',
  'customer.anonymized': 'Kundendaten gelöscht (anonymisiert)',
  'customer.exported': 'Datenauskunft erstellt',
  'customer.contact_created': 'Ansprechpartner angelegt',
  'customer.contact_updated': 'Ansprechpartner geändert',
  'customer.contact_deleted': 'Ansprechpartner entfernt',
  'customer.portal_access_granted': 'Portalzugang eingerichtet',
  'customer.portal_access_revoked': 'Portalzugang gesperrt',
  'customer.area_grants_updated': 'Bereichsfreigaben geändert',
  'ticket.deleted': 'Ticket gelöscht',
  'ticket_config.area_created': 'Ticketbereich angelegt',
  'ticket_config.area_updated': 'Ticketbereich geändert',
  'ticket_config.area_deleted': 'Ticketbereich gelöscht',
  'ticket_config.status_created': 'Status angelegt',
  'ticket_config.status_updated': 'Status geändert',
  'ticket_config.status_deleted': 'Status gelöscht',
  'portal.registered': 'Kunde hat sich registriert',
  'portal.ticket_created': 'Anfrage im Portal gestellt',
  'portal.profile_updated': 'Kunde hat Daten geändert',
  'portal.company_user_invited': 'Kunde hat Kollegen eingeladen',
  'portal.company_user_enabled': 'Kunde hat Kollegen freigegeben',
  'portal.company_user_disabled': 'Kunde hat Kollegen gesperrt',
  'repair.received': 'Gerät angenommen',
  'repair.quote_approved': 'Kostenvoranschlag freigegeben',
  'repair.quote_rejected': 'Kostenvoranschlag abgelehnt',
  'repair.picked_up': 'Gerät abgeholt',
  'repair.access_code_viewed': 'Gerätecode angezeigt',
  'repair.access_code_set': 'Gerätecode gesetzt',
  'repair.access_code_removed': 'Gerätecode gelöscht',
  'device.created': 'Gerät angelegt',
  'device.updated': 'Gerät geändert',
  'device.deleted': 'Gerät gelöscht',
  'form.created': 'Formular angelegt',
  'form.updated': 'Formular-Einstellungen geändert',
  'form.published': 'Formular veröffentlicht',
  'form.deleted': 'Formular gelöscht',
  'form.submitted_internal': 'Formular intern ausgefüllt',
  'm365.connection_created': 'Microsoft 365 verbunden',
  'm365.wizard_completed': 'Microsoft 365 per Assistent eingerichtet',
  'm365.connection_updated': 'Microsoft-365-Verbindung geändert',
  'm365.connection_deleted': 'Microsoft-365-Verbindung entfernt',
  'm365.consent_granted': 'Administratorzustimmung erteilt',
  'm365.consent_failed': 'Administratorzustimmung fehlgeschlagen',
  'm365.mailbox_created': 'Postfach hinzugefügt',
  'm365.mailbox_updated': 'Postfach geändert',
  'm365.mailbox_deleted': 'Postfach entfernt',
  'm365.test_mail': 'Testnachricht gesendet',
  'appointment.created': 'Termin angelegt',
  'zabbix.instance_created': 'Monitoring-Quelle verbunden',
  'mail.settings_created': 'SMTP-Server eingerichtet',
  'mail.settings_updated': 'SMTP-Einstellungen geändert',
  'mail.settings_deleted': 'SMTP-Einstellungen entfernt',
  'mail.test': 'Testnachricht (SMTP) gesendet',
  'contract.created': 'Vertrag angelegt',
  'contract.document_generated': 'Vertrags-PDF erzeugt',
  'contract.document_sent': 'Vertragsdokument versendet',
  'contract.signed_uploaded': 'Unterschriebener Vertrag hochgeladen',
  'contract_template.created': 'Vertragsvorlage angelegt',
  'contract_template.updated': 'Vertragsvorlage geändert',
  'contract_template.deleted': 'Vertragsvorlage gelöscht',
  'report.exported': 'Bericht exportiert',
  'billing.released': 'Zur Abrechnung freigegeben',
  'hourly_rate.created': 'Stundensatz angelegt',
  'monitor.created': 'Statusmonitor angelegt',
  'monitor.updated': 'Statusmonitor geändert',
  'monitor.deleted': 'Statusmonitor gelöscht',
  'monitor.url_rotated': 'Statusmonitor: neue URL erzeugt',
  'mail.template_updated': 'E-Mail-Vorlage geändert',
  'mail.template_reset': 'E-Mail-Vorlage zurückgesetzt',
  'mail.layout_updated': 'E-Mail-Design geändert',
  'user.deleted': 'Benutzer gelöscht',
  'user.mfa_reset': 'Zwei-Faktor-Anmeldung zurückgesetzt',
  'user.mfa_reset_cli': 'Zwei-Faktor-Anmeldung per Kommandozeile zurückgesetzt',
  'auth.mfa_enabled': 'Zwei-Faktor-Anmeldung eingerichtet',
  'auth.mfa_disabled': 'Zwei-Faktor-Anmeldung abgeschaltet',
  'auth.mfa_failed': 'Falscher Bestätigungscode',
  'auth.mfa_recovery_used': 'Wiederherstellungscode verwendet',
  'auth.mfa_recovery_regenerated': 'Neue Wiederherstellungscodes',
  'hourly_rate.updated': 'Stundensatz geändert',
  'hourly_rate.deleted': 'Stundensatz gelöscht',
  'user.hourly_rates_updated': 'Stundensätze eines Mitarbeiters geändert',
  'ticket.watchers_added': 'Beteiligte hinzugefügt',
  'billing.change_requested': 'Änderungsantrag gestellt',
  'record.unlocked_edit': 'Gesperrten Vorgang mit Begründung bearbeitet',
  'billing.change_approved': 'Änderungsantrag genehmigt',
  'billing.change_rejected': 'Änderungsantrag abgelehnt',
  'printer.created': 'Drucker angelegt',
  'printer.updated': 'Drucker geändert',
  'printer.deleted': 'Drucker gelöscht',
  'repair.public_access_reset': 'Neue PIN für die Statusabfrage erzeugt',
  'billing.withdrawn': 'Abrechnungsfreigabe zurückgenommen',
  'billing.transferred': 'In Powerbird übernommen',
  'billing.not_billable': 'Als „Keine Rechnung“ abgeschlossen',
  'billing.reopened': 'Abrechnung wieder geöffnet',
  'billing.returned': 'Abrechnung mit Rückfrage zurückgegeben',
  'billing.exported': 'Abrechnung exportiert',
  'flat_rate.created': 'Pauschale angelegt',
  'flat_rate.updated': 'Pauschale geändert',
  'flat_rate.deleted': 'Pauschale gelöscht',
  'repair.charge_added': 'Pauschale zur Reparatur hinzugefügt',
  'repair.charge_removed': 'Pauschale von Reparatur entfernt',
  'data_protection.completed': 'Datenschutz-Assistent abgeschlossen',
  'retention.updated': 'Aufbewahrungsfristen geändert',
  'retention.applied': 'Aufbewahrungsfristen angewendet',
  'contract.updated': 'Vertrag geändert',
  'contract.deleted': 'Vertragsentwurf gelöscht',
  'contract.renewed': 'Vertrag automatisch verlängert',
  'contract.expired': 'Vertrag abgelaufen',
  'sla.created': 'SLA-Richtlinie angelegt',
  'sla.updated': 'SLA-Richtlinie geändert',
  'sla.deleted': 'SLA-Richtlinie gelöscht',
  'automation.created': 'Automatisierung angelegt',
  'automation.updated': 'Automatisierung geändert',
  'automation.deleted': 'Automatisierung gelöscht',
  'zabbix.instance_updated': 'Zabbix-Instanz geändert',
  'zabbix.instance_deleted': 'Zabbix-Instanz entfernt',
  'zabbix.hosts_imported': 'Zabbix-Hosts importiert',
  'zabbix.webhook_secret_rotated': 'Zabbix-Webhook-Geheimnis erneuert',
  'monitoring.acknowledged': 'Zabbix-Problem bestätigt',
  'monitoring.host_updated': 'Monitoring-Host zugeordnet',
  'monitoring.group_updated': 'Hostgruppe zugeordnet',
  'appointment.updated': 'Termin geändert',
  'appointment.cancelled': 'Termin abgesagt',
};

export const auditActionLabel = (action: string) => LABELS[action] ?? action;

export const AUDIT_ACTION_GROUPS = [
  { value: 'auth.', label: 'Anmeldung & Sicherheit' },
  { value: 'user.', label: 'Benutzer' },
  { value: 'role.', label: 'Rollen' },
  { value: 'customer.', label: 'Kunden' },
  { value: 'portal.', label: 'Kundenportal' },
  { value: 'ticket', label: 'Tickets & Konfiguration' },
  { value: 'repair.', label: 'Reparaturen' },
  { value: 'device.', label: 'Geräte' },
  { value: 'form.', label: 'Formulare' },
  { value: 'm365.', label: 'Microsoft 365' },
  { value: 'appointment.', label: 'Termine' },
  { value: 'zabbix.', label: 'Monitoring-Quellen' },
  { value: 'mail.', label: 'E-Mail-Versand' },
  { value: 'contract.', label: 'Verträge' },
  { value: 'sla.', label: 'SLA' },
  { value: 'automation.', label: 'Automatisierungen' },
  { value: 'monitoring.', label: 'Monitoring' },
  { value: 'tenant.', label: 'Unternehmen' },
  { value: 'platform.', label: 'Plattform' },
];
